import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

import AluDatos from "./AluDatos";
import AluFamilia from "./AluFamilia";
import AluNovedades from "./AluNovedades";
import CtaCte from "./CtaCte";


const Alumnos = (props) => {


  const [codigo, setCodigo] = useState("")
  const [nombre, setNombre] = useState("")


  const [tabVisible, setTabVisible] = useState(1);


  const [activo, setActivo] = useState(false)
  const [noteditable, setNotEditable] = useState(true)

  // ventana de búsqueda
  const [vermodal, setVermodal] = useState(false)
  //const [searchcodigo, setSearchCodigo] = useState("")
  //const [searchnombre, setSearchNombre] = useState("")  
  //const [searchactivo, setSearchActivo] = useState(false)  
  //const [searchgrilla, setSearchGrilla] = useState([])  
  //const [searchMessage, setSearchMessage] = useState("")

  // ventana de confirmación
  const [vermodalconf, setVermodalConf] = useState(false)

  // toast
  const [showToast, setShowToast] = useState(false);
  const [textoToast, setTextoToast] = useState("");

  /*
     async function    handleOnChangeActivo(e){
      setSearchActivo(!searchactivo); 
      setSearchMessage("");
   }
   
  */



  const handleTabVer = (tab, event) => {

    setTabVisible(tab);
  };




  const location = useLocation();


  useEffect(() => {

    var { unalumno } = location.state || {};
    console.log('Alumno a mostrar:', unalumno);


    if (unalumno) {
      setCodigo(unalumno[0].Alu_IdAlu);
      setNombre(unalumno[0].Alu_Apellido + ', ' + unalumno[0].Alu_Nombre);
    }
  }, []);
  return (
    <div >




      <div className="container-fluid">

        <div className="row">

          <div className="text-justify col-lg-2 col-sm-2 col-md-2">
            <h3>Alumnos</h3>
          </div>
          <div className="text-justify col-lg-4 col-sm-4 col-md-4">
            <h5>{nombre}</h5>
          </div>
        </div>
        <div className="row">

          <div className="text-justify col-lg-2 col-sm-2 col-md-2">

            <div className="d-grid gap-2">
              <button className="filtraruno" type="button" onClick={(event) => handleTabVer(1, event)}>Datos Principales</button>
              <button className="filtraruno" type="button" onClick={(event) => handleTabVer(2, event)}>Familia / Responsable</button>
              <button className="filtraruno" type="button" onClick={(event) => handleTabVer(3, event)}>Novedades</button>
              <button className="filtraruno" type="button" onClick={(event) => handleTabVer(4, event)}>Cta. Corriente</button>
            </div>
          </div>

          <div className={tabVisible == 1 ? "col-xs-12 col-lg-10 col-sm-10 col-md-10" : "col-xs-12 col-lg-10 col-sm-10 col-md-10 d-none"}>

            <AluDatos unalumno={codigo} grusu={props.grusu} />
          </div>
          <div className={tabVisible == 2 ? "col-xs-12 col-lg-10 col-sm-10 col-md-10" : "col-xs-12 col-lg-10 col-sm-10 col-md-10 d-none"}>
            <AluFamilia unalumno={codigo} />
          </div>
          <div className={tabVisible == 3 ? "col-xs-12 col-lg-10 col-sm-10 col-md-10" : "col-xs-12 col-lg-10 col-sm-10 col-md-10 d-none"}>
            <AluNovedades unalumno={codigo} />
          </div>
          <div className={tabVisible == 4 ? "col-xs-12 col-lg-10 col-sm-10 col-md-10" : "col-xs-12 col-lg-10 col-sm-10 col-md-10 d-none"}>
            <CtaCte unalumno={codigo} />
          </div>
        </div>

      </div>

      <ToastContainer position="bottom-end">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>

          <Toast.Body>{textoToast}</Toast.Body>
        </Toast>
      </ToastContainer>










      <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <div id="liveToastmsg" className="toast" role="alert" aria-live="assertive" aria-atomic="true">

          <div className="toast-body">

          </div>
        </div>
      </div>













    </div>
  );
};

export default Alumnos;

